import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbsoluteValuePipe } from './absolute-value.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ AbsoluteValuePipe ],
    exports: [ AbsoluteValuePipe ],
})
export class AbsoluteValuePipeModule {}
